package com.example.mystybag.appCore.logic

import com.example.mystybag.core.logic.base.BottomSheetChild

class PhoneSelectionBottomSheetChild(
    override val viewModel: PhoneSelectionBottomSheetViewModel
) : BottomSheetChild(
    viewModel = viewModel,
    showNotch = false,
    removeBottomSheetPadding = true,
    useWebDialogInsets = true
)
